import script from "./ProgressDialV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgressDialV2.vue?vue&type=script&setup=true&lang=ts"

import "./ProgressDialV2.vue?vue&type=style&index=0&id=25f24f3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25f24f3d"]])

export default __exports__